import type { IconProps } from './types';

const SortIcon = (_props: IconProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
      <mask id="mask0_3280_3496" maskUnits="userSpaceOnUse" x="0" y="0" width="25" height="24">
        <rect x="0.5" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3280_3496)">
        <path
          d="M11.5288 17.5C11.3163 17.5 11.1382 17.428 10.9945 17.2842C10.8507 17.1404 10.7789 16.9622 10.7789 16.7496C10.7789 16.537 10.8507 16.3589 10.9945 16.2154C11.1382 16.0718 11.3163 16 11.5288 16H13.4615C13.674 16 13.8521 16.0719 13.9959 16.2157C14.1396 16.3595 14.2115 16.5377 14.2115 16.7503C14.2115 16.9629 14.1396 17.141 13.9959 17.2846C13.8521 17.4282 13.674 17.5 13.4615 17.5H11.5288ZM7.65383 12.75C7.44134 12.75 7.26323 12.6781 7.11948 12.5343C6.97573 12.3904 6.90385 12.2122 6.90385 11.9997C6.90385 11.7871 6.97573 11.609 7.11948 11.4654C7.26323 11.3218 7.44134 11.25 7.65383 11.25H17.3365C17.549 11.25 17.7271 11.3219 17.8709 11.4657C18.0146 11.6095 18.0865 11.7877 18.0865 12.0003C18.0865 12.2129 18.0146 12.391 17.8709 12.5346C17.7271 12.6782 17.549 12.75 17.3365 12.75H7.65383ZM4.75 7.99998C4.5375 7.99998 4.35938 7.92807 4.21563 7.78425C4.07188 7.64045 4 7.46225 4 7.24965C4 7.03707 4.07188 6.85898 4.21563 6.7154C4.35938 6.5718 4.5375 6.5 4.75 6.5H20.25C20.4625 6.5 20.6406 6.57191 20.7843 6.71573C20.9281 6.85954 21 7.03774 21 7.25033C21 7.46293 20.9281 7.64102 20.7843 7.7846C20.6406 7.92818 20.4625 7.99998 20.25 7.99998H4.75Z"
          fill="#124E78"
        />
      </g>
    </svg>
  );
};

export default SortIcon;
